import { useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import './cartPage.css';
import axios from 'axios';
import { loadStripe } from "@stripe/stripe-js";
import Navbar from "../../components/navbars/Navbar";
import CartItem from "../../components/cartItems/CartItem";
import { CartContext } from '../../context/CartContext'; 
import { UserContext } from "../../context/UserProvider";
import CheckoutModal from '../../components/modals/checkoutModal';
import AlbumDesignTermsModal from "../../components/modals/AlbumDesignTermsModal";
import AddShippingAddressModal from '../../components/modals/addShippingAddress'
import { IoTrash } from "react-icons/io5";
import AddressForm from "../../components/forms/AddressForm";
import { useUser } from "../../context/UserProvider";
import { fetchAuthSession } from "aws-amplify/auth";
import ReactLoading from 'react-loading'

// Load your Stripe publishable key
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY);

export default function CartPage() {
    const { cartItems } = useContext(CartContext); 
    const { cognitoUser, mongoUser, updateMongoUser } = useUser()
    const [checkoutActive, setCheckoutActive] = useState(false);
    const [subTotal, setSubTotal] = useState(0);
    const [tax, setTax] = useState(null); 
    const [shipping, setShipping] = useState(0);
    const [total, setTotal] = useState(0); 
    const [clientSecret, setClientSecret] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [userAddress, setUserAddress] = useState(null);  
    const [addingNewAddress, setAddingNewAddress] = useState(false); 
    const [selectedAddress, setSelectedAddress] = useState("")
    const [showAddressModal, setShowAddressModal] = useState(false)
    const [addingShippingAddress, setAddingShippingAddress] = useState(false)
    const [loadingCheckout, setLoadingCheckout] = useState(false)
    const [albumDesignTerms, setAlbumDesignTerms] = useState(false)
    const [albumDesignAcknowledgment, setAlbumDesignAcknowledgment] = useState(null);
    const [showDuplicateOffer, setShowDuplicateOffer] = useState(false);
    const [showDuplicateSelection, setShowDuplicateSelection] = useState(false);
    const [duplicates, setDuplicates] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [checkoutLoading, setCheckoutLoading] = useState(false)
    const navigate = useNavigate();
    // Extract products and albums safely
    const albums = cartItems?.albums || [];
    const products = cartItems?.products || [];
    const isCartEmpty = albums.length === 0 && products.length === 0;
    // Calculate subtotal
    function calculateSubTotal(items) {
        const subTotal = items.reduce((acc, item) => acc + (Number(item.price) * item.quantity || 0), 0);
        setSubTotal(subTotal.toFixed(2));
    }
    // Handle Album Design Acknowledgement
    const handleAcknowledge = (acknowledgmentData) => {
        console.log("✅ Terms acknowledged:", acknowledgmentData);
    
        // ✅ Save the acknowledgment in order
        setAlbumDesignAcknowledgment(acknowledgmentData);
    
        // ✅ Close the modal
        setAlbumDesignTerms(false);
    
        // ✅ Now proceed to checkout modal
        setShowModal(true);
    };
    // Calculate total
    function calculateTotal(subTotal, shipping, tax) {
        const taxValue = tax? Number(tax) : 0;
        const total = (Number(subTotal) + Number(shipping) + Number(taxValue)).toFixed(2);
        setTotal(total);
    }

    // Handle checkout process
    async function handleCheckout() {
        try {
            console.log(cartItems)
            if (!cognitoUser) {
                alert('Please log in to proceed with checkout.');
                navigate('/login');
                return;
            }

            // Fetch user's shipping address
            
            
            
            console.log("Selected Address:", selectedAddress)
            const shippingAddress = selectedAddress
            console.log("Shipping Address:", shippingAddress)
            if (
                !shippingAddress || // Check if shippingAddress is missing
                shippingAddress === "" ||
                !shippingAddress.street?.trim() ||
                !shippingAddress.city?.trim() ||
                !shippingAddress.state?.trim() ||
                !shippingAddress.zip?.trim()
            ) {
                alert('Please select or add a shipping address');
                return;
            }

            const hasAlbums = cartItems.some(item => Boolean(item.albumName) || Boolean(item.productName));
                if (hasAlbums && !albumDesignTerms) {
                    setAlbumDesignTerms(true);
                    return; // Stop execution until terms are acknowledged
                }
            // Show modal to confirm shipping address
            if (cartItems.length > 0) {
                setShowDuplicateOffer(true);
                return;
            }
            setShowModal(true)
            
            
        } catch (error) {
            console.error('Error during checkout:', error.response ? error.response.data : error);
        }
    }

    // Proceed with order after confirming address
    async function handleProceedWithOrder(shippingAddress) {
        try {
            setLoadingCheckout(true);
            console.log('Proceeding with order for address:', shippingAddress);
    
            const session = await fetchAuthSession();
            const idToken = session.tokens?.idToken?.toString();
            if (!idToken) {
                console.error("❌ No ID Token found.");
                setLoadingCheckout(false);
                return;
            }
    
            if (!albumDesignAcknowledgment) {
                alert("❌ You must acknowledge the album design terms before proceeding.");
                setLoadingCheckout(false);
                return;
            }
            // Close the modal
            
            setIsLoading(true)
            // Step 1: Create a new order in MongoDB
            const newOrderResponse = await axios.post(
                `${import.meta.env.VITE_ORDERS_API}/orders/${mongoUser._id}/new-order`,
                {
                    cartItems: cartItems.map(item => ({
                        albumName: item.albumName,
                        productName: item.productName,
                        albumOptions: item.albumOptions,
                        productOptions: item.productOptions,
                        stripeProductId: item.albumOptions?.productId || item.productOptions?.productId || item.stripeProductId,
                        stripePriceId: item.albumOptions?.priceId || item.productOptions?.priceId || item.stripePriceId,
                        coverOptions: item.coverSelection,
                        coverName: item.coverName,
                        coverType: item.coverType,
                        quantity: item.quantity,
                        priceId: item.priceId,  
                        price: item.price,
                        navbarImage: item.navbarImage,
                        dupPriceId: item.albumOptions?.dupPriceId || item.productOptions?.dupPriceId     
                    })),
                    userId: mongoUser._id,
                    firstName: mongoUser.firstName,
                    lastName: mongoUser.lastName,
                    shippingAddress: shippingAddress,
                    paymentStatus: 'pending',
                    albumDesignTermsAcknowledged: albumDesignAcknowledgment
                },
                {
                    headers: {
                        'Authorization': `Bearer ${idToken}`, // Attach Cognito token
                        'Content-Type': 'application/json'
                    }
                }
            );
            console.log('✅ New Order Response Data:', newOrderResponse.data);
    
            const { orderId } = newOrderResponse.data;
            console.log('✅ Order created with ID:', orderId);
    
            // Step 2: Request Stripe Checkout Session
            const stripeCheckoutResponse = await axios.post(
                `${import.meta.env.VITE_ORDERS_API}/orders/${mongoUser._id}/stripe-create-checkout`,
                {
                    mongoUser,
                    orderId, // Pass order ID
                    cartItems: cartItems.map(item => ({
                        stripePriceId: item.albumOptions?.priceId || item.productOptions?.priceId || item.stripePriceId, // Stripe expects priceId, not raw price
                        quantity: item.quantity
                    }))
                },
                {
                    headers: {
                        'Authorization': `Bearer ${idToken}`, // Attach Cognito token
                        'Content-Type': 'application/json'
                    }
                }
            );
            console.log('MongoUser Shipping Address:', mongoUser.shippingAddress)
            const { sessionId } = stripeCheckoutResponse.data;
            console.log('✅ Stripe session ID:', sessionId);
            console.log('✅ Stripe Checkout Response Data:', stripeCheckoutResponse.data);
            // Step 3: Redirect user to Stripe Checkout
            const stripe = await stripePromise;
            const { error } = await stripe.redirectToCheckout({ sessionId });
    
            if (error) {
                console.error('❌ Error in Stripe Checkout redirection:', error.message);
                setLoadingCheckout(false)
            }
        } catch (error) {
            // Handle errors from API calls
            console.error('❌ Error proceeding with order:', error.response ? error.response.data.error : error);
            alert(error.response?.data?.error || 'Something went wrong while placing the order.');
            setLoadingCheckout(false)
        } finally {
            setIsLoading(false)
        }
    }
    
    const handleAddShippingAddress = async (addressData) => {
        try {
            console.log('📌 New address submitted:', addressData);
    
            const session = await fetchAuthSession();
            const idToken = session.tokens?.idToken?.toString();
            if (!idToken) {
                console.error("❌ No ID Token found.");
                return;
            }
    
            // ✅ Validate before sending
            if (
                !addressData.street ||
                !addressData.city ||
                !addressData.state ||
                !addressData.zip
            ) {
                alert("❌ Invalid address: Missing required fields.");
                return;
            }
            
            console.log("📌 Address data being sent to API:", JSON.stringify({ shippingAddress: addressData }));

            // Prepare request headers
            const headers = {
                "Authorization": `Bearer ${idToken}`,
                "Content-Type": "application/json"
            };
            setIsLoading(true)

            // ✅ Send a single object, not an array
            const response = await axios.put(
                `${import.meta.env.VITE_USERS_API}/user/${cognitoUser.userId}`,
                { shippingAddress: addressData }, // ✅ Send only an object
                { headers }
            );
    
            console.log('✅ User shipping address updated:', response.data);
    
            // ✅ Update UserContext with new data
            updateMongoUser({
                shippingAddress: [...mongoUser.shippingAddress, addressData] // Append new address
            });
    
            // ✅ Close modal after short delay
            setTimeout(() => {
                setShowModal(false);
            }, 100);
    
        } catch (error) {
            console.error('❌ Error submitting new address:', error.response?.data || error.message);
        } finally {
            setIsLoading(false)
        }   
        
    };
    
    
    

  

    // Calculate subtotal when cartItems change
    useEffect(() => {
        calculateSubTotal(cartItems);
        console.log("Cart Items",cartItems)
    }, [cartItems]);

    // Update total when subtotal, shipping, or tax changes
    useEffect(() => {
        calculateTotal(subTotal, shipping, tax);
    }, [subTotal, shipping, tax]);

    useEffect(() => {
        console.log("🔥 Cart updated in CartPage:", cartItems);
        cartItems.forEach((item, index) => {
            console.log(`🖼️ Item ${index} navbarImage:`, item.navbarImage);
        });
    }, [cartItems]);

    useEffect(() => {
        calculateSubTotal(cartItems);
    }, [cartItems]);  // ✅ Recalculates subtotal when cartItems change
    
    useEffect(() => {
        calculateTotal(subTotal);
    }, [subTotal]);

    useEffect(() => {
        console.log("🔥 Cart in CartPage (should contain items):", cartItems);
    }, [cartItems]);

    return (
        <div>
            <Navbar />
            <div className="cartPageContainer">
                <div className="shipAndCart">

                
                <div className="shippingArea">
                    {/* ✅ If there are addresses, display them */}
                    <div className="shippingAddress" style={{justifyContent: 'center', alignItems: 'center'}}>
                        {mongoUser?.shippingAddress.length === 0 &&
                            <p style={{color: '#3c3c3c'}}>No Shipping Address Found</p>
                        }   
                            <p style={{color: '#3c3c3c'}}>Shipping Addresses</p>
                            <button onClick={() => setShowAddressModal(true)} style={{padding: '8px', width: '175px', backgroundColor: 'dodgerblue'}}>
                                Add Address
                            </button>

                            {/* ✅ Show Address Form when "Add Address" is clicked */}
                            {showAddressModal && (
                                <AddShippingAddressModal onClose={() => setShowAddressModal(false)}>
                                    <h2>Add Shipping Address</h2>
                                    <AddressForm 
                                        onSubmit={(data) => {
                                            handleAddShippingAddress(data);
                                            setShowAddressModal(false); // ✅ Close modal after submission
                                        }} 
                                        onCancel={() => setShowAddressModal(false)} 
                                    />
                                </AddShippingAddressModal>
                            )}
                        </div>

                            
                        {mongoUser?.shippingAddress && mongoUser.shippingAddress.length > 0 && (
                            mongoUser.shippingAddress.map((item, index) => (
                                <div 
                                    key={index} 
                                    className={`shippingAddress ${selectedAddress === item ? "selected" : ""}`} 
                                    onClick={() => setSelectedAddress(item)} // ✅ Clicking div selects radio
                                    style={{
                                        cursor: "pointer",
                                        border: selectedAddress === item ? "2px solid blue" : "1px solid gray",
                                        padding: "10px",
                                        marginBottom: "10px",
                                        borderRadius: "5px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px"
                                    }}
                                >
                                    {/* The radio button will reflect the selected state */}
                                    <input
                                        type="radio"
                                        name="shippingAddress"
                                        checked={selectedAddress === item}
                                        onChange={() => setSelectedAddress(item)} // ✅ Ensures state updates properly
                                        style={{ cursor: "pointer" }}
                                    />
                                    <div>
                                        <h4>{item.street}</h4>
                                        <h4>{item.city}, {item.state} {item.zip}</h4>
                                    </div>
                                </div>
                            ))                        
                        )}

                </div>



                <div className="cartItemArea">
                    {(!cartItems || cartItems.length === 0 || 
                      (cartItems.every(item => (item.albums?.length === 0 && item.products?.length === 0)))) ? (
                        <h1>Your Cart is Empty</h1>
                    ) : (
                        cartItems.map((item, index) => (
                            <CartItem
                            key={index}
                            index={index}
                            albumId={item.albumOptions ? item._id : undefined}  // Only set albumId if it's an album
                            productId={item.albumOptions ? undefined : item._id}  // Pass the album or product option ID
                            stripePriceId={item.priceId}
                            stripeProductId={item.productId}
                            albumName={item.albumOptions ? item.albumName || 'Unnamed Album' : undefined}
                            productName={item.albumOptions ? undefined : item.productName || 'Unnamed Product'}
                            price={item.price}
                            size={item.size}
                            image={item.imageUrl}
                            quantity={item.quantity || 1}
                            pages={item.pages}
                            coverImage={item.coverImage}
                            coverType={item.coverType}
                            coverName={item.coverName}
                            albumOptions={item.albumOptions}
                            productOptions={item.productOptions}  // Ensure productOptions are passed for products
                            navbarImage={item.navbarImage}
                            loading={isLoading}
                        />
                        
                        ))
                    )}
                </div>
                </div>
    
                {cartItems.length > 0 && !cartItems.every(item => item.albums?.length === 0 && item.products?.length === 0) && (
                    <div className="chargeArea">
                        
                        {selectedAddress && (
                            <div className="selectedAddressDisplay">
                                <h4>Selected Address:</h4>
                                <p>{selectedAddress?.street}, {selectedAddress?.city}, {selectedAddress?.state} {selectedAddress?.zip}</p>
                            </div>
                        )}
                        
                        <div className="costArea">
                            <div className="charges">
                                <h4>Subtotal:</h4>
                                <h4>${subTotal}</h4>
                            </div>
                            <div className="charges">
                                <h4>Shipping:</h4>
                                <h4 style={{ color: '#3f9a59' }}>
                                    {shipping === 0 ? 'Free' : `$${shipping}`}
                                </h4>
                            </div>
                            <div className="charges">
                                <h4>Tax: </h4>
                                {tax !== null ? (
                                    <h4>${tax.toFixed(2)}</h4>
                                ) : (
                                    <h6 style={{alignItems: 'center'}}>Calculated at checkout</h6>
                                )}
                            </div>
                            <div>
                                <p style={{color: '#242424'}}>___________________________</p>
                            </div>
                        </div>
                        <div className="totalAndCheckout">
                            <h2>Total Cost: ${cartItems.reduce((acc, item) => acc + (item.price * (item.quantity || 1)), 0).toFixed(2)} + tax</h2>
                            <div className="checkoutButtons">
                                <button onClick={handleCheckout} style={{ backgroundColor: 'royalblue', padding: '15px 25px'}}>
                                    {loadingCheckout && <ReactLoading type="spin" color="white" height={20} width={20} />}
                                    Begin Checkout 
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal with shipping address confirmation or address form */}
                {showModal && (
                    <CheckoutModal show={showModal} onClose={() => setShowModal(false)}>
                        <div className="modal-content">
                            { selectedAddress !== "" ? (
                                <>
                                    <h3>Confirm Shipping Address</h3>
                                    <h6 style={{color: '#3c3c3c', textAlign: 'center'}}>{selectedAddress?.street}</h6>
                                    <h6 style={{color: '#3c3c3c', textAlign: 'center'}}>{selectedAddress?.city}, {selectedAddress?.state} {selectedAddress?.zip}</h6>
                                    {loadingCheckout ? (
                                        <ReactLoading type="spin" color="dodgerblue" size={30} />
                                    ) : (
                                        <button 
                                            style={{margin: '10px', backgroundColor: 'royalblue'}} 
                                            onClick={() => handleProceedWithOrder(selectedAddress)}
                                            disabled={loadingCheckout} // Disable button while loading
                                        >
                                            Yes, use this address
                                        </button>
                                    )}
                
                                    <button 
                                        style={{margin: '10px', color: '#3c3c3c'}} 
                                        onClick={() => setShowModal(false)}
                                        disabled={loadingCheckout} // Disable cancel button while loading
                                    >
                                        Select a different address
                                    </button>
                                </>
                            ) : (
                                alert("You must select a shipping address")
                            )}
                        </div>
                    </CheckoutModal>
                )}
                {albumDesignTerms && (
                    <AlbumDesignTermsModal 
                        isOpen={albumDesignTerms}
                        onClose={() => setAlbumDesignTerms(false)}
                        onAcknowledge={handleAcknowledge}
                        user={mongoUser} 
                    />
                )
                }
            </div>
        </div>
    );
}